export class DataTransform {

  public static transfromGrids(grids) {
    const newGrids = Object.assign({}, grids);
    const newEntities = newGrids.entities.slice();
    newEntities.forEach((item, i) => {
      if (newEntities[i].type === 'destination') {
        newEntities[i] = Object.assign({}, newEntities[i], newEntities[i].input);
      }
    });
    newGrids.entities = newEntities;
    return newGrids;
  }
}
